import { ResponsiveContainer, Bar, BarChart, XAxis, CartesianGrid } from "recharts";
import { BAR_CHART_DATA } from "../../../../../../data/rhsAssessmentData";

const CustomLabel = (props: { x: any; y: any; name: string, value: any; }) => {

  const { x, y, name, value } = props;
  return <>
    <text
      x={x + 40}
      y={y - 2}
      dy={-4}
      fontSize='14'
      fill="#BDBDC5"
      textAnchor="middle">{name}</text>
    <text
      x={x + 1150}
      y={y - 2}
      dy={-4}
      fontSize='14'
      fill="#BDBDC5"
      textAnchor="middle">{value}</text>
  </>
};

export default function CustomBarChart() {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        layout="vertical"
        height={250}
        data={BAR_CHART_DATA}
        margin={{ top: 40, bottom: 20 }}
      >
        <CartesianGrid horizontal={false} stroke="#3A3A4A" strokeDasharray="3 3" />
        <XAxis type="number" tickMargin={10} tickCount={4} />
        <Bar dataKey="value" barSize={20} radius={[5, 0, 0, 5]} fill="#444CE7" stackId="a" label={CustomLabel} />
        <Bar dataKey="remaining" barSize={20} radius={[5, 0, 0, 5]} fill="#3A3A4A" stackId="a" />
      </BarChart>
    </ResponsiveContainer>
  );
}